// extracted by mini-css-extract-plugin
export default {"container":"GlobalNavigationFallbackCard_container__MTEzY","truncate":"GlobalNavigationFallbackCard_truncate__MGJiZ"};